import keyMirror from 'react-utils/keyMirror';
import { createAction, createRequestTypes, createRequestActions } from './utils';
export const HubContactActionTypes = keyMirror({
  FETCH_IS_HUB_CONTACT: null,
  LOAD_IS_HUB_CONTACT: null
});
export const FetchHubContactActionTypes = createRequestTypes(HubContactActionTypes.FETCH_IS_HUB_CONTACT);
export const FetchHubContact = createRequestActions(FetchHubContactActionTypes);
export const loadIsHubContact = () => createAction(HubContactActionTypes.LOAD_IS_HUB_CONTACT);